import { Component, OnInit } from '@angular/core';
import {AppService} from '../app.service'

declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export const ROUTES: RouteInfo[] = [
    // { path: '/dashboard', title: 'Dashboard',  icon: 'pe-7s-graph', class: '' },
    // { path: '/user', title: 'User Profile',  icon:'pe-7s-user', class: '' },
    // { path: '/table', title: 'Table List',  icon:'pe-7s-note2', class: '' },
    // { path: '/typography', title: 'Typography',  icon:'pe-7s-news-paper', class: '' },
    // { path: '/icons', title: 'Icons',  icon:'pe-7s-science', class: '' },
    // { path: '/maps', title: 'Maps',  icon:'pe-7s-map-marker', class: '' },
    // { path: '/notifications', title: 'Notifications',  icon:'pe-7s-bell', class: '' },
    {path: '/products', title:'Create Orders', icon:'pe-7s-plus', class:''} ,
    {path: '/consult', title:'Questions', icon:'pe-7s-note2', class:''},
    {path: '/order', title:'Order Questions', icon:'pe-7s-note2', class:''} ,
    {path: '/reorder', title:'Re-Order Questions', icon:'pe-7s-note2', class:''} ,
    {path: '/wiki', title:'Product Info', icon:'pe-7s-news-paper', class:''}
    // // { path: '/upgrade', title: 'Upgrade to PRO',  icon:'pe-7s-rocket', class: 'active-pro' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  public brand;
  public baseUrl;

  constructor(private appService:AppService) { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
    this.baseUrl = window.location.host.split('.').splice(1).join('.');
      this.brand = "GHC Agent";
  }
  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };
  logOut(){
    this.appService.LogOut()
  }
}
